import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';
import { SEARCH_LENGTH } from '@utils/utils';
import { SearchViewModel } from '@api/v3';

export const useUrlSearch = (
  slug: string | undefined,
  initialData?: SearchViewModel
) => {
  return useQuery({
    queryKey: ['urlSearch', slug],
    queryFn: () => {
      if (!slug) {
        throw new Error('Slug is required');
      }
      return callService(
        { service: 'SearchesService', method: 'searchesUrl', version: 'v3' },
        { s: slug }
      );
    },
    initialData: typeof window === 'undefined' ? initialData : undefined,
    staleTime: 30000,
    cacheTime: 5 * 60 * 1000,
    enabled: Boolean(slug),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
  });
};

export const useLocationSearch = (searchTerm: string) => {
  return useQuery({
    queryKey: ['locationItems', searchTerm],
    queryFn: async () => {
      return callService(
        { service: 'SearchesService', method: 'searchesHotel', version: 'v3' },
        { s: searchTerm.toLowerCase() }
      );
    },
    enabled: searchTerm.length >= SEARCH_LENGTH,
    staleTime: 30000, // Consider data fresh for 30 seconds
    cacheTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
